import(/* webpackMode: "eager" */ "/vercel/path0/app/firebase/counters.ts");
;
import(/* webpackMode: "eager", webpackExports: ["recordUserActivity"] */ "/vercel/path0/app/firebase/streaks.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/utils/cacheInvalidation.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/utils/cacheUtils.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.4.5_@babel+core@7.28.0_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_react-dom@1_6334gtu3fqjbrkbe3mmn7wg22u/node_modules/next/dist/client/script.js");
